import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterEditor, FilterRecord, Operator } from '@services/core-services/filters';
import { InputsComponent } from '@enginuity/core/molecules/inputs/inputs.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-filter-entry-editor-boolean',
  imports: [CommonModule, InputsComponent],
  templateUrl: './filter-entry-editor-boolean.component.html',
  styleUrl: './filter-entry-editor-boolean.component.scss',
})
export class FilterEntryEditorBooleanComponent implements FilterEditor, OnDestroy {
  private _record!: FilterRecord;
  private subscription: Subscription | undefined;

  get record(): FilterRecord {
    return this._record;
  }

  @Input()
  set record(value: FilterRecord) {
    this._record = value;
    this.setOptions(value);
  }

  get multiselect() {
    return [Operator.In, Operator.NotIn].includes(this.record.rule.operator!);
  }

  @Input() value: any | undefined;

  @Output() onChange: EventEmitter<string> = new EventEmitter<string>();

  public options: { value: any; label: any }[] = [];

  ngOnDestroy(): void {
    if (this.subscription) this.subscription.unsubscribe();
  }

  private setOptions(_: FilterRecord) {
    const result = [
      { key: true, value: 'True' },
      { key: false, value: 'False' },
    ];
    this.options = result.map(this.toOptions);
  }

  private toOptions(e: any) {
    return {
      value: e.hasOwnProperty('key') ? e.key : e,
      label: e.hasOwnProperty('value') ? e.value : e,
    };
  }

  onSelectionChange(option: any) {
    this.onChange.emit(option.value);
  }
}
